export default "__VITE_PUBLIC_ASSET__73c024b5__"